import React, { useEffect, useRef, useState } from 'react';
import '../components/btnCard.css';
import {
	BtnBold,
	BtnItalic,
	BtnUndo,
	BtnRedo,
	BtnNumberedList,
	BtnClearFormatting,
	ContentEditableEvent,
	Editor,
	EditorProvider,
	Toolbar,
	BtnBulletList,
	BtnLink
} from 'react-simple-wysiwyg';
import { StartButton } from '../../../../Utils/saveButton';
import { useDispatch } from 'react-redux';
import { useMutation, useQuery } from 'react-query';
import { axiosInstance } from '../../../../../config/axiosInstance';
import { globalEnv } from '../../../../../config/baseConfig';
import { SetNotificationAction } from '../../../../../redux/actions/notificationAction';
import { stateNotificationsEnum } from '../../../../Utils/notification';
import { useTypedSelector } from '../../../../../hooks/useTypeSelector';
import ParentModal from '../../../../Utils/Components/parentModal';
import { MeavanaUsersModal } from '../components/modals/meavanaUsersModal';
import { StandaloneUsersModal } from '../components/modals/standaloneUsersModal';
import placeholder from '../../../../../assets/images/img.jpg';
import { Tag } from '../../../../Utils/Components/tag';
import { useParams } from 'react-router-dom';
import { EmailTag } from '../components/emailTag';
import validator from 'validator';
import { EmailsSenderselect } from '../../../SettingsPage/emailSenderSelect';
import axios from 'axios';
import LoadingAnimComponent from '../../../../Utils/LoadingAnimations/loadingAnimation';

export function SendEmailInCampaign() {
	const { campaignId } = useParams();
	const { selectedTemplates } = useParams();
	const [tags, setTags] = useState<string[]>([]);
	const [replyToAdrs, setReplyToAdrs] = useState<string[]>([]);
	const [object, setObject] = useState('');
	const [content, setContent] = useState('');
	const [isChanged, setIsChanged] = useState(false);
	const [isSaving, setIsSaving] = useState(false);
	const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);
	const [isMeavanaUsersModalOpen, setIsMeavanaUsersModalOpen] = useState(false);
	const [isStandaloneUsersModalOpen, setIsStandaloneUsersModalOpen] =
		useState(false);
	const [emailErrorMsg, setemailErrorMsg] = useState({
		message: '',
		error: false
	});

	const templatesList = selectedTemplates!
		.split(',')
		.map((item) => item.trim());
	const [templates, setTemplate] = useState(templatesList);

	const [emailAdrText, setEmailAdrText] = useState('');
	const [meavanaUsersEmailAdrs, setMeavanaUsersEmailAdrs] = useState<string[]>(
		[]
	);
	const [standaloneUsersEmailAdrs, setStandaloneUsersEmailAdrs] = useState<
		string[]
	>([]);

	const [selectedDefaultEmailSender, setSelectedDefaultEmailSender] =
		useState<string>('');

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});
	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	async function fetchSettingsData() {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data } = await axios.get(`${globalEnv.BASE_URL}/settings`, config);
		return data;
	}

	const { data, isLoading, isError } = useQuery([], () => fetchSettingsData(), {
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		staleTime: 5000
	});

	useEffect(() => {
		if (data != null) {
			setReplyToAdrs(data.outreachDefaultReplyToAdrs);
			setSelectedDefaultEmailSender(data.outreachDefaultSenderAdr);
		}
	}, [data]);

	function onChange(e: ContentEditableEvent) {
		setContent(e.target.value);
	}

	function addTag() {
		setTags([...tags, '']);
	}

	const verifEmailFormat = (email = '') => {
		if (validator.isEmpty(email, { ignore_whitespace: true })) {
			setemailErrorMsg({
				error: true,
				message: 'Please enter your email address'
			});
			return true;
		} else {
			if (!validator.isEmail(email)) {
				setemailErrorMsg({
					error: true,
					message: 'Email must be a valid format'
				});
				return true;
			} else if (email.indexOf(' ') >= 0) {
				setemailErrorMsg({
					error: true,
					message: 'Email must not contain white spaces'
				});
				return true;
			} else {
				setemailErrorMsg({ error: false, message: '' });
				return false;
			}
		}
	};

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const startSendingReq = async () => {
		const dto = {
			campaignId: campaignId,
			replyToAdrs: replyToAdrs,
			senderAdr: selectedDefaultEmailSender,
			recipients: standaloneUsersEmailAdrs.concat(meavanaUsersEmailAdrs),
			object: object,
			path: templates[0],
			content: content
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axiosInstance.post(
			globalEnv.BASE_URL + `/outreach/campaign/send-bulk-emails`,
			dto,
			config
		);
		return response;
	};

	const dispatch = useDispatch();
	const startSending = useMutation(startSendingReq, {
		onMutate: () => setIsSaving(true),
		onSuccess: () => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully started sending emails.'
				})
			);
			// navigate('../documents');
		},
		onError: () => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't start sending."
				})
			);
		}
	});

	return (
		<div className="pt-16 pl-18 dark:bg-gray-800 transition-all duration-300">
			{isLoading ? (
				<LoadingAnimComponent />
			) : (
				<div>
					<ParentModal
						visible={isMeavanaUsersModalOpen}
						setModalOpen={setIsMeavanaUsersModalOpen}
						isChanged={isChanged}
						setIsChanged={setIsChanged}
						isWarnModalOpen={isWarnModalOpen}
						setIsWarnModalOpen={setIsWarnModalOpen}
					>
						<MeavanaUsersModal
							emailAdrs={meavanaUsersEmailAdrs}
							setEmailAdrs={setMeavanaUsersEmailAdrs}
							setModalOpen={setIsMeavanaUsersModalOpen}
						/>
					</ParentModal>

					<ParentModal
						visible={isStandaloneUsersModalOpen}
						setModalOpen={setIsStandaloneUsersModalOpen}
						isChanged={isChanged}
						setIsChanged={setIsChanged}
						isWarnModalOpen={isWarnModalOpen}
						setIsWarnModalOpen={setIsWarnModalOpen}
					>
						<StandaloneUsersModal
							emailAdrs={standaloneUsersEmailAdrs}
							setEmailAdrs={setStandaloneUsersEmailAdrs}
							setModalOpen={setIsStandaloneUsersModalOpen}
						/>
					</ParentModal>

					<div className="w-full mt-2 pr-3 px-3">
						<h3 className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-lg font-bold mb-1">
							Email Tags
						</h3>
						<div className="flex flex-row space-x-2 dark:bg-gray-700 bg-gray-200 transition-all duration-300 rounded-xl p-3">
							{tags.map((tag, index) => (
								<Tag
									name={tag}
									isMine={true}
									setIsChanged={setIsChanged}
									index={index}
									setTags={setTags}
									tags={tags}
								/>
							))}

							{tags.length > 0 ? (
								<div
									className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500
													bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
													dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
													dark:text-gray-300 text-gray-600 hover:text-gray-200"
								>
									<span className="text-xs font-bold mx-1" onClick={addTag}>
										➕
									</span>
								</div>
							) : (
								<div className="inline-block">
									<h3
										className="text-xs font-bold mx-1 mb-1 dark:text-gray-400 text-gray-700"
										onClick={addTag}
									>
										This email has no Tags
									</h3>

									<div
										className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500
																	bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
																	dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
																	dark:text-gray-300 text-gray-600 hover:text-gray-200"
									>
										<span className="text-xs font-bold mx-1" onClick={addTag}>
											Create email's first Tag ➕
										</span>
									</div>
								</div>
							)}
						</div>
					</div>

					<div className="w-full px-3 mt-4 text-left">
						<div className="w-full h-auto">
							<label className="block uppercase tracking-wide text-gray-700  dark:text-gray-300 text-xs font-bold">
								Email sender address
							</label>
							<div className="">
								<EmailsSenderselect
									selectedEmailAdrs={selectedDefaultEmailSender}
									setSelectedEmailAdrs={setSelectedDefaultEmailSender}
									setIsChanged={setIsChanged}
								/>
							</div>
						</div>
					</div>

					<div className="w-full px-3 mt-4 text-left">
						<div className="w-full h-auto">
							<label className="block uppercase tracking-wide text-gray-700  dark:text-gray-300 text-xs font-bold mb-2">
								Reply to addresses
							</label>
							<div className="flex flex-row">
								<input
									className="inputStyle py-2"
									id="grid-last-name"
									type="text"
									placeholder="address@email.com"
									onChange={(e) => {
										if (!emailErrorMsg.error) setEmailAdrText(e.target.value);
									}}
									onBlur={(e) => {
										verifEmailFormat(e.target.value);
									}}
									onFocus={() => {
										setemailErrorMsg({ error: false, message: '' });
									}}
									value={emailAdrText}
								/>
								{emailErrorMsg.error ? (
									<p className="text-red-500 text-xs italic text-right ml-auto h-4">
										{emailErrorMsg.message}
									</p>
								) : (
									<div className="mb-4" />
								)}
								<button
									type="button"
									className="btn btn-outline btn-sm btn-primary mr-2 ml-3 mt-1 "
									onClick={() => {
										if (!verifEmailFormat(emailAdrText)) {
											const updatedEmailAdrs: string[] =
												replyToAdrs != null
													? replyToAdrs.concat(emailAdrText)
													: [emailAdrText];
											setReplyToAdrs(updatedEmailAdrs);
											setEmailAdrText('');
										}
									}}
								>
									Add Email address
								</button>
							</div>
							<div className="flex flex-wrap space-x-2 mt-3">
								{replyToAdrs != null &&
									replyToAdrs.map((adr, index) => (
										<div className="mb-2">
											<EmailTag
												key={adr}
												adr={adr}
												index={index}
												setEmailAdrs={setReplyToAdrs}
												allAdrs={replyToAdrs}
											/>
										</div>
									))}
							</div>
						</div>
					</div>

					<div className="w-full mt-6">
						<h3 className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-lg font-bold mb-2 px-3">
							Selected Email Addresses to be contacted in this campaign
						</h3>
						<div className="flex flex-row w-full">
							<StyledBtn
								title="Meavana Users:"
								subTitle={meavanaUsersEmailAdrs.length.toString()}
								imgPath={placeholder}
								action={() => setIsMeavanaUsersModalOpen(true)}
							/>
							<StyledBtn
								title="Standalone Emails:"
								subTitle={standaloneUsersEmailAdrs.length.toString()}
								imgPath={placeholder}
								action={() => setIsStandaloneUsersModalOpen(true)}
							/>
						</div>
					</div>

					<div className="w-full mt-2 pr-3 px-3">
						<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">
							Email Subject
						</label>
						<input
							className="inputStyle"
							id="grid-last-name"
							type="text"
							placeholder="Write your email subject here"
							onChange={(e) => {
								setObject(e.target.value);
							}}
							value={object}
						/>
					</div>
					<div className="mt-4 px-3">
						<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">
							Email Content
						</label>
						<EditorProvider>
							<Editor
								style={{ color: 'white', minHeight: '200px' }}
								value={content}
								onChange={(e) => onChange(e)}
								placeholder="Write your email content here"
							>
								<Toolbar>
									<BtnUndo />
									<BtnRedo />
									<BtnBold />
									<BtnItalic />
									<BtnNumberedList />
									<BtnBulletList />
									<BtnLink />
									<BtnClearFormatting />
								</Toolbar>
							</Editor>
						</EditorProvider>
					</div>
					<div className="w-full flex justify-end mt-3 pr-3 ">
						<StartButton
							text="Start sending"
							isSaving={isSaving}
							saveFunc={() => startSending.mutate()}
						/>
					</div>

					<div className="h-3"></div>
				</div>
			)}
		</div>
	);
}

type UserBtnType = {
	title: string;
	subTitle?: any;
	imgPath: string;
	action: () => void;
};

export const StyledBtn = ({
	title,
	subTitle,
	imgPath,
	action
}: UserBtnType) => {
	const ref: any = useRef<null>(null);
	return (
		<div
			className="btn-card-zoom cursor-pointer"
			onClick={() => {
				action();
			}}
			ref={ref}
		>
			<div
				className="btn-card-zoom-image "
				style={{
					backgroundImage: `url('${imgPath}')`
				}}
			></div>
			<h1
				style={{
					fontSize: ref.current ? ref.current.offsetWidth / 15 : '2em'
				}}
				className="btn-card-zoom-text text-white"
			>
				{title}
			</h1>
			<h1
				style={{
					fontSize: ref.current ? ref.current.offsetWidth / 15 : '2em'
				}}
				className="btn-card-zoom-text text-purple-600 ml-2"
			>
				{subTitle}
			</h1>

			<div className="absolute inset-0 bg-gradient-to-t from-black/75 opacity-0 hover:opacity-100 transition-all duration-500 text-center" />
		</div>
	);
};
